import { CalendarDays, MapPin, QrCode } from 'lucide-react';

export const getMetaRows = ({ dateLabel, location }) => {
  const rows = [];
  if (dateLabel) rows.push({ id: 'date', icon: CalendarDays, label: dateLabel });
  if (location) rows.push({ id: 'location', icon: MapPin, label: location });
  return rows;
};

export function TemplateMeta({ rows, centered = false, textColor = '#FFFFFF', textShadow = 'none', family = 'Inter, sans-serif', tracking = '0.08em', uppercase = false }) {
  if (!rows?.length) return null;

  return (
    <div className={`space-y-2 ${centered ? 'text-center' : ''}`}>
      {rows.map((row) => {
        const Icon = row.icon;
        return (
          <p
            key={row.id}
            className={`flex items-center gap-2 ${centered ? 'justify-center' : ''}`}
            style={{
              color: textColor,
              textShadow,
              fontFamily: family,
              letterSpacing: tracking,
              textTransform: uppercase ? 'uppercase' : 'none',
              fontSize: 'clamp(0.8rem, 1.7vw, 1rem)'
            }}
          >
            <Icon className="w-4 h-4 opacity-90" />
            {row.label}
          </p>
        );
      })}
    </div>
  );
}

export function TemplateFooter({ showSiteLink, siteUrl, showQrCode, textColor, accentColor, darkSurface = false, centered = false }) {
  return (
    <div className={`mt-auto flex items-end gap-3 ${centered ? 'justify-center' : 'justify-between'}`}>
      {showSiteLink ? (
        <div className={`rounded-xl px-3 py-2 ${darkSurface ? 'bg-black/55' : 'bg-white/90'} ${centered ? 'max-w-[84%]' : 'max-w-[72%]'}`}>
          <p className="text-[11px] uppercase tracking-[0.12em] font-semibold" style={{ color: accentColor || '#9A6B65' }}>
            Link do site
          </p>
          <p className="text-xs truncate" style={{ color: darkSurface ? '#FFFFFF' : textColor, textShadow: 'none' }}>
            {siteUrl || 'vireinoiva.com.br'}
          </p>
        </div>
      ) : (
        <div />
      )}
      {showQrCode && (
        <div className={`rounded-xl p-2 ${darkSurface ? 'bg-white/95' : 'bg-white/88'} border border-white/50`}>
          <QrCode className={`w-10 h-10 ${darkSurface ? 'text-[#111111]' : 'text-[#1C1C1C]'}`} />
        </div>
      )}
    </div>
  );
}

export function TemplateCta({ text, textColor, textShadow, mode = 'editorial_label', center = false }) {
  if (!text) return null;

  return (
    <p
      className={`text-xs tracking-[0.16em] uppercase font-semibold ${center ? 'text-center' : ''}`}
      style={{
        color: textColor,
        opacity: 0.92,
        textShadow,
        borderBottom: mode === 'line_label' ? '1px solid rgba(255,255,255,0.45)' : 'none',
        borderTop: mode === 'signature' ? '1px solid rgba(255,255,255,0.35)' : 'none',
        paddingTop: mode === 'signature' ? '0.6rem' : 0,
        paddingBottom: mode === 'line_label' ? '0.35rem' : 0
      }}
    >
      {text}
    </p>
  );
}
